// src/components/docsupload/ContractSupportingDocsWrapper.tsx
import React from 'react';
import { useParams } from 'react-router-dom';
import GenericSupportingDocs from './GenericSupportingDocs';

const ContractSupportingDocsWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const user = localStorage.getItem('user') || ''; // or fetch from context/store
  const tenantId = user ? JSON.parse(user).tenantId : '';
  if (!id || !tenantId) {
    return <div className="text-red-600">Missing required parameters</div>;
  }

  return (
    <GenericSupportingDocs
      entityType="CONTRACT"
      entityId={id}
      tenantId={tenantId}
    />
  );
};

export default ContractSupportingDocsWrapper;